import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import { Card, CardHeader, CardBody, Row, Col, FormGroup, Label, CustomInput, Input, InputGroup, InputGroupAddon, Button } from 'reactstrap';
import { alertService } from 'components/Varios/alert_service.js';

import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import TooltipItem from "components/Varios/Tooltip.js";

//import FileUpload from "components/Varios/FileUpload.js";
//import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';
import { mensajeCamposIncompletos } from './constants';
import axios from 'axios';
import { authHeader } from 'helpers/auth-header';

const API_URL = configData.SERVER_URL
var tieneDiscapacidad = false;

const tiposDiscapacidades = {
    "LENGUAJE": "5",
    "PSICOLOGICO": "6",
    "AUDITIVA": "1",
    "FÍSICA": "2",
    "INTELECTUAL": "3",
    "VISUAL": "4"
}

export class DatosGeneralesData {
    idpersona: number = 0;
    tienediscapacidad: string = "";
    tiposangre: string = "";
    tipodiscapacidad: string = "";
    porcentajedisc: number = 0;
    numcarnetconadis: string = "";
    sexo: string = "";
    estadopersona: string = "";
    tipoidentificacion: string = "";
    numeroidentificacion: string = "";
    tienefamildiscapacidad: string = "";
}

export class SaludData {
    idpersona: number = 0;
    idhojavida: number = 0;
    username: string = "";
    discaptipo: string = "";
    discapporc: number = 0;
    discapcarnet: string = "";
    fechaemisiondiscap?: string = "";
    fechacaducidaddiscap?: string = "";
    //fechaemisiondiscap: Date = new Date();
    //fechacaducidaddiscap: Date = new Date();
    refarchivocarnet: string = "";
    tieneenfercatastrofica: string = "N";
    refarchivoenfercatastrofica: string = "";
}

interface SaludDataState {
    currentUser: any;
    loading: boolean;
    dtoData: DatosGeneralesData;
    htoData: SaludData;
    tipoDiscapacidadList: Array<any>;
    tipoSangreList: Array<any>;
    tipoVacunaList: Array<any>;
    error: null;
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
    solicitudActualizacion: boolean;
    errorAlert: HTMLElement | undefined;
    tipoDiscapacidadSelected:string

}

export class Salud extends React.Component<RouteComponentProps<{}>, SaludDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, dtoData: new DatosGeneralesData(),
            htoData: new SaludData(), tipoDiscapacidadList: [], tipoSangreList: [], tipoVacunaList: [], error: null, tiposEvidencia: [], filesData: [],
            solicitudActualizacion: false,
            errorAlert: undefined,
            tipoDiscapacidadSelected:""
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.buscarPersona = this.buscarPersona.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.obtenerDatosSalud = this.obtenerDatosSalud.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                }
            }
        );

        this.setState({
            loading: true
        });
    }

    componentWillUnmount() {
        alertService.clear("saludError");
    }

    cargarDatos() {
        //API PARA OBTENER TIPOS DE DISCAPACIDAD
        fetch(API_URL + "DatosSalud/TipoDiscapacidad")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoDiscapacidadList: result.entTabla.map(d => ({
                                "value": d.codigo.toString(),
                                "label": d.descripcion
                            }

                            )),
                        });
                    } else {
                        //console.log(result["strMensaje"])

                        alertService.error("Ocurrió un error al obtener los tipos de discapacidad.", { id: "saludError" })
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        tipoDiscapacidadList: [],
                    });
                    alertService.error("Ocurrió un error al obtener los tipos de discapacidad.", { id: "saludError" })
                }
            )

        //API PARA OBTENER TIPOS DE SANGRE
        fetch(API_URL + "DatosSalud/TipoSangre")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoSangreList: result.entTabla.map(d => ({
                                "value": d.descripcion,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los tipos de sangre.")
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        tipoSangreList: []
                    });
                    alertService.error("Ocurrió un error al obtener los tipos de sangre.")
                }
            )

        // API PARA OBTENER PERSONA
        fetch(API_URL + "DatosGenerales/PersonaId/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        if (result.entTabla[0]) {
                            if (result.entTabla[0]['tienediscapacidad'] === "S") {
                                tieneDiscapacidad = true;
                            }
                            else {
                                tieneDiscapacidad = false;
                            }

                            //this.buscarPersona(result.entTabla[0].numeroidentificacion)
                            this.obtenerDatosSalud(this.state.currentUser.idpersona, result.entTabla[0])
                        }
                    } else if (result.strEstado === "N") {
                        alertService.error("Ocurrió un error al obtener los datos de la persona.")
                    }
                    else {
                        alertService.error(result)
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        dtoData: new DatosGeneralesData()
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER TIPOS DE VACUNA
        fetch(API_URL + "DatosSalud/TipoVacuna")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoVacunaList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los tipos de vacuna.")
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        tipoVacunaList: []
                    });
                    alertService.error("Ocurrió un error al obtener los tipos de vacuna.")
                }
            )
    }

    obtenerDatosSalud(idPersona, dtoData) {
        // API PARA OBTENER PERSONA
        fetch(API_URL + "DatosSalud/HojaVidaByIdPersona/" + idPersona)
            .then(res => res.json())
            .then(
                async (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        if (result.entTabla[0]) {
                            var hto = result.entTabla[0]
                           

                            const { htoInfo, dtoInfo } = await this.buscarPersona(dtoData.numeroidentificacion, hto, dtoData)


                            //this.setState({
                            //    dtoData: dtoData,
                            //    tiposEvidencia: this.cargarEvidencias(dtoData.tienediscapacidad === "S"),
                            //    loading: false
                            //});

                            this.setState({
                                dtoData: dtoInfo,
                                tiposEvidencia: this.cargarEvidencias(dtoInfo.tienediscapacidad === "S"),
                                htoData: htoInfo,
                                loading: false,
                                tipoDiscapacidadSelected: htoInfo.discaptipo
                            });

                        }
                    } else if (result.strEstado === "N") {
                        alertService.error("Ocurrió un error al obtener la hoja de vida de la persona.")
                    }
                    else {
                        alertService.error(result)
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        htoData: new SaludData()
                    });
                    alertService.error("Ocurrió un error al obtener la hoja de vida de la persona.")
                }
            )
    }

    handleSelectChange(value, name, tipo = null, htoData,tipodiscapacidadSelected?:string) {
        if (name === 'tiposangre') {
            var dto = { ...this.state.dtoData };
            dto[name] = value;

            this.setState({ dtoData: dto });
        }
        else {
            var hto = { ...htoData, discaptipo: tipodiscapacidadSelected??"" };
            hto[name] = value;
            this.setState({ htoData: hto });
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var dto = { ...this.state.htoData };
        dto[name] = value;
        this.setState({ htoData: dto });
    }

    async buscarPersona(identificacion, htoData,dtoData) {
        var dto = { ...dtoData }
        var hto = { ...htoData }

        const URL = API_URL + "DatosGenerales/Discapacidad/" + identificacion;

        try {
            const respuesta = await axios.get(URL,{
                headers: authHeader()
            })
            if(respuesta.data.strEstado === "S"){
                
                const result = respuesta.data;

                if (result.entTabla[0].nombres) {
                    dto.tienediscapacidad = "S"
                    hto.discapcarnet = result.entTabla[0].codigoConadis
                    hto.discapporc = result.entTabla[0].porcentajeDiscapacidad
                    hto.discaptipo = tiposDiscapacidades[result.entTabla[0].deficienciaPredomina]

                    dto.tipodiscapacidad = tiposDiscapacidades[result.entTabla[0].deficienciaPredomina]
                    dto.numcarnetconadis = result.entTabla[0].codigoConadis

                    //console.log(tiposDiscapacidades[result.entTabla[0].deficienciaPredomina])

                    if (result.entTabla[0].fechaConadis) {
                        var info = result.entTabla[0].fechaConadis.split(' ')[0].split('/');
                        var date = info[2] + "/" + info[1] + "/" + info[0]
                        hto.fechaemisiondiscap = date
                    }

                    tieneDiscapacidad = true;

                    //dto.sexo = (result.entTabla[0].sexo === "MUJER" ? "F" : "M")
                }
                else {
                    const htmlerror: any = <div className='mb-2 error-small '>Ocurrió un error al obtener los tipos de discapacidad</div>;
                    this.setState({ errorAlert: htmlerror })
                }
            }
        } catch (error) {
            alertService.error("Ocurrió un error: " + error)
        }

        
        

        // fetch(API_URL + "DatosGenerales/Discapacidad/" + identificacion)
        //     .then(res => res.json())
        //     .then(
        //         (result) => {
        //             if (result.strEstado === "S") {
        //                 if (result.entTabla[0].nombres) {
        //                     dto.tienediscapacidad = "S"
        //                     hto.discapcarnet = result.entTabla[0].codigoConadis
        //                     hto.discapporc = result.entTabla[0].porcentajeDiscapacidad
        //                     hto.discaptipo = tiposDiscapacidades[result.entTabla[0].deficienciaPredomina]

        //                     dto.tipodiscapacidad = tiposDiscapacidades[result.entTabla[0].deficienciaPredomina]
        //                     dto.numcarnetconadis = result.entTabla[0].codigoConadis

        //                     //console.log(tiposDiscapacidades[result.entTabla[0].deficienciaPredomina])

        //                     if (result.entTabla[0].fechaConadis) {
        //                         var info = result.entTabla[0].fechaConadis.split(' ')[0].split('/');
        //                         var date = info[2] + "/" + info[1] + "/" + info[0]
        //                         hto.fechaemisiondiscap = date
        //                     }

        //                     tieneDiscapacidad = true;

        //                     //dto.sexo = (result.entTabla[0].sexo === "MUJER" ? "F" : "M")
        //                 }
        //             } else {
        //                 const htmlerror: any = <div className='mb-2 error-small '>Ocurrió un error al obtener los tipos de discapacidad</div>;
        //                 this.setState({ errorAlert: htmlerror })
        //             }
        //         },
        //         (error) => {
        //             alertService.error("Ocurrió un error: " + error)
        //         }
        //     )


        //ESTO SI ESTABA COMENTADO, NO DESCOMENTAR
        //this.setState({
        //    htoData: { ...hto },
        //    dtoData: dto,
        //});

        return {
            htoInfo: hto ,
            dtoInfo: dto,
        }
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var hto = { ...this.state.htoData, discaptipo: this.state.tipoDiscapacidadSelected };
        var filesData = this.state.filesData;
        let formIsValid = true;
        let mensajeError = "";

        if (tieneDiscapacidad) {
            if (hto['fechaemisiondiscap'] && hto['fechacaducidaddiscap'] && hto['fechaemisiondiscap'] > hto['fechacaducidaddiscap']) {
                alertService.error("Error: La fecha de caducidad debe ser mayor a la fecha de emisión.");
                return;
            }

            if (!this.state.solicitudActualizacion) {
                alertService.error("Error: Por favor marque la declaración de veracidad.");
                return;
            }

            //if (filesData.length <= 0 && !hto.refarchivocarnet) {
            //    alertService.error("Error: Por favor ingrese evidencia.");
            //    return;
            //}
        }

        forma.forEach((value, clave) => {
            if (!value) {
                if (!tieneDiscapacidad && clave != 'evidencias') {
                    formIsValid = false;
                }
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;

            if (typeof hto[clave] === 'number') {
                hto[clave] = Number(value);
            }
            else if (typeof hto[clave] === 'boolean') {
                hto[clave] = Boolean(value);
            }
            else

                hto[clave] = value;

            if (clave === 'discapporc') {
                dto['porcentajedisc'] = Number(value);
                hto['discapporc'] = Number(value);
            }

            if (clave === 'discapcarnet') {
                dto['numcarnetconadis'] = String(value);
            }

            if (clave === 'discaptipo') {
                dto['tipodiscapacidad'] = String(this.state.tipoDiscapacidadSelected);
            }

            if (clave === 'fechaemisiondiscap' || clave === 'fechacaducidaddiscap') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                hto[clave] = date.toJSON();
            }

            if (!tieneDiscapacidad) {
                dto['tipodiscapacidad'] = "";
                dto['numcarnetconadis'] = "";
                hto['Discapcarnet'] = "";
                hto['Discaptipo'] = "";
                delete hto['fechaemisiondiscap'];
                delete hto['fechacaducidaddiscap'];
                //dto['numcarnetconadis'] = "";
            }
        });

        if (hto.fechaemisiondiscap) {
            var value = String(hto['fechaemisiondiscap'])
            var info = value.split('/').join('-');
            var date = new Date(String(info))
            hto['fechaemisiondiscap'] = date.toJSON();
        }

        if (hto.fechacaducidaddiscap) {
            var value = String(hto['fechacaducidaddiscap'])
            var info = value.split('/').join('-');
            var date = new Date(String(info))
            hto['fechacaducidaddiscap'] = date.toJSON();
        }

        if (dto.porcentajedisc) {
            dto.porcentajedisc = Number(dto.porcentajedisc);
        }

        if (hto.discapporc) {
            hto.discapporc = Number(hto.discapporc);
        }

        if (tieneDiscapacidad) {
            dto['tipodiscapacidad'] = this.state.tipoDiscapacidadSelected;
            dto['porcentajeDisc'] = +this.state.htoData.discapporc
        }

        dto.idpersona = this.state.currentUser.idpersona;
        hto.idpersona = this.state.currentUser.idpersona;
        //console.log(hto)
        //console.log(dto)

        const data = JSON.stringify({
            "tpersona": dto, "thojavida": hto
        });

        if (formIsValid) {
            fetch(API_URL + "FormularioController/PostDatosSalud", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: data,
            })
                .then(response => response.json())
                .then(
                    (responseJson) => {
                        if (responseJson["strEstado"] === "N") {
                            alertService.error(responseJson["strMensaje"])
                        }
                        else if (responseJson["strEstado"] === "S") {
                            alertService.success("La sección de Salud ha sido actualizada correctamente.")
                            authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                            const persona = JSON.stringify({
                                "entidad": String(this.state.dtoData.idpersona)
                            });

                            if (this.state.solicitudActualizacion) {
                                fetch(API_URL + "FormularioController/PostSolicitudActualizacion", {
                                    method: 'POST',
                                    body: persona
                                })
                                    .then(response => response.json())
                                    .then(success => {
                                        // Do something with the successful response
                                    })
                                    .catch(error => alertService.error(error) //console.log(error)
                                    );
                            }

                            if (filesData.length > 0) {
                                var formFilesData = new FormData();

                                filesData.map((fileData) => {
                                    formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                });

                                formFilesData.append('idhojavida', responseJson.thojavida.idhojavida);

                                fetch(API_URL + "FormularioController/PostFilesDatosGenerales", {
                                    method: 'POST',
                                    body: formFilesData
                                })
                                    .then(response => response.json())
                                    .then(success => {
                                        // Do something with the successful response
                                    })
                                    .catch(error => alertService.error(error)//console.log(error)
                                    );
                            }
                        }

                        else {
                            alertService.error("Ocurrió un error: " + responseJson)
                        }
                    },
                    (error) => {
                        //console.log(error)
                        alertService.error("Ocurrió un error: " + error)
                    }

                )
        } else {
            //console.log(mensajeError);
            if (mensajeError) {
                alertService.error(mensajeError);
            }
            else {
                alertService.error(mensajeCamposIncompletos());
            }
        }
    }

    handleChange(event) {
        var dto = { ...this.state.dtoData };
        var hto = { ...this.state.htoData };
        dto[event.target.name] = event.target.value
        hto[event.target.name] = event.target.value

        if (event.target.name === "tienediscapacidad") {
            dto['tienediscapacidad'] = event.target.value

            if (event.target.value === 'S') {
                tieneDiscapacidad = true;
            }
            else {
                tieneDiscapacidad = false;
                hto['fechaemisiondiscap'] = ""
                hto['fechacaducidaddiscap'] = ""
                hto['discaptipo'] = ""
                Array.from(document.querySelectorAll("input")).forEach(
                    input => (input.value = "")
                );
            }

            var tiposEvidencia = this.cargarEvidencias(tieneDiscapacidad);
        }

        this.setState({
            dtoData: dto,
            htoData: hto,
            tiposEvidencia: tiposEvidencia
        })
    }

    toggleCheckbox(event) {
        this.setState(
            {
                solicitudActualizacion: !this.state.solicitudActualizacion,
            }
        );
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
        });
    }

    cargarEvidencias(tienediscapacidad) {
        var tiposEvidencia;

        if (tienediscapacidad) {
            tiposEvidencia = [
                { "value": "INC", "label": "Carnet CONADIS" }
            ];
        }
        return tiposEvidencia;
    }

    descargarEvidencias(hojavida: SaludData) {
        var evidencias = new Array();
        var dto = this.state.dtoData;
        if (hojavida.refarchivocarnet) {
            evidencias.push({ name: "INC" + dto.numeroidentificacion + ".PDF", url: API_URL + "DatosGenerales/Refarchivo/INC/" + this.state.currentUser.idpersona });
        }
        if (hojavida.refarchivoenfercatastrofica) {
            evidencias.push({ name: "DOCUMENTO-" + dto.numeroidentificacion + ".PDF", url: API_URL + "DatosGenerales/Refarchivo/ENC/" + this.state.currentUser.idpersona });
        }
        return evidencias;
    }

    //vistaPrevia(key) {

    //    if (key === "VistaPrevia") {
    //        alertService.clear();

    //        const data = JSON.stringify({
    //            "idpersona": this.state.currentUser.idpersona
    //        });

    //        var btnVistaPrevia = document.getElementById("btnVistaPrevia");
    //        const i = document.createElement("i");
    //        i.setAttribute("id", "loadingEnviar")
    //        i.setAttribute("class", "fa fa-spin fa-spinner")
    //        if (btnVistaPrevia != null) {
    //            btnVistaPrevia.textContent = " Cargando . . . ";
    //            btnVistaPrevia.insertBefore(i, null)
    //            btnVistaPrevia.setAttribute("disabled", "true");
    //        }

    //        fetch(API_URL + "AcuerdoMediosElectronicos/VistaPrevia", {

    //            method: 'POST',
    //            headers: { 'Content-Type': 'application/json' },
    //            body: data,

    //        })
    //            .then(response => {
    //                response.blob()
    //                    .then(blob => {
    //                        let url = window.URL.createObjectURL(blob);

    //                        var loadingEnviar = document.getElementById("loadingEnviar");
    //                        if (loadingEnviar != null) {
    //                            var parentNode = loadingEnviar.parentNode;
    //                            if (parentNode != null) {
    //                                parentNode.removeChild(loadingEnviar);
    //                            }
    //                        }
    //                        var btnVistaPrevia = document.getElementById("btnVistaPrevia");
    //                        if (btnVistaPrevia != null) {
    //                            btnVistaPrevia.textContent = "Firmar Acuerdo de Medios Eléctronicos";
    //                            btnVistaPrevia.removeAttribute("disabled");
    //                        }

    //                        this.setState({ urlPDF: url, isOpenModal: true });

    //                    });
    //            }
    //            )

    //    }
    //}

    public render() {
        let contents = this.state.loading

            ?
            <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

        /* : this.renderForm(this.state.tipoDiscapacidadList, this.state.tipoSangreList, this.state.tipoVacunaList, this.state.tiposEvidencia, this.state.htoData, this.state.tipoDiscapacidadSelected);*/
            : (
                <>
                    <Row> <Col></Col> </Row>
                    <Row>
                        <Col md={12}>
                            {this.state.errorAlert}
                            <Card className="principal">
                                <CardHeader>
                                    <h5 className="title">SALUD</h5>
                                </CardHeader>
                                <CardBody className="main-content">
                                    <div>
                                        <form onSubmit={this.handleSave}>

                                            <FormGroup row>
                                                <Label for="tipo_sangre" md={3}>Tipo de sangre*: </Label>
                                                <Col md={3}>
                                                    <SelectItem
                                                        options={this.state.tipoSangreList}
                                                        value={this.state.dtoData.tiposangre ? this.state.dtoData.tiposangre.trim() : ""}
                                                        placeholder="Tipo de sangre"
                                                        name="tiposangre"
                                                        id="tiposangre"
                                                        //icon="fa-tint"
                                                        icon="tipo_sangre"
                                                        tieneDiscapacidad={true}
                                                        onChange={this.handleSelectChange}
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label for="tienediscapacidad" sm={3}>Discapacidad*: </Label>
                                                <Col sm={9}>
                                                    <div className="row ml-1" >
                                                        {
                                                            this.state.dtoData.tienediscapacidad === "S" ?
                                                                <CustomInput
                                                                    className="col-md-1 mr-4"
                                                                    type="radio"
                                                                    checked={this.state.dtoData.tienediscapacidad === "S"}
                                                                    value="S"
                                                                    id="tienediscapacidad"
                                                                    name="tienediscapacidad"
                                                                    onChange={this.handleChange}
                                                                    label="Sí"
                                                                    disabled={true}
                                                                />
                                                                :
                                                                <CustomInput
                                                                    className="col-md-6"
                                                                    type="radio"
                                                                    value="N"
                                                                    id="tienediscapacidad2"
                                                                    name="tienediscapacidad"
                                                                    checked={this.state.dtoData.tienediscapacidad === "N"}
                                                                    onChange={this.handleChange}
                                                                    label="En el MSP, no registra información suya sobre alguna discapacidad."
                                                                    disabled={true}
                                                                />
                                                        }

                                                    </div>
                                                </Col>
                                            </FormGroup>
                                            {
                                                (tieneDiscapacidad ?
                                                    <div>
                                                        <FormGroup row>
                                                            <Label for="tipo_discapacidad" md={3}>Tipo discapacidad</Label>
                                                            <Col md={3}>
                                                                <SelectItem
                                                                    options={this.state.tipoDiscapacidadList}
                                                                    value={this.state.htoData.discaptipo}
                                                                    placeholder="Tipo discapacidad"
                                                                    name="discaptipo"
                                                                    id="discaptipo"
                                                                    //icon="fa-wheelchair"
                                                                    icon="discapacidad"
                                                                    tieneDiscapacidad={tieneDiscapacidad}
                                                                    onChange={this.handleSelectChange}
                                                                    disabled={true}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row>
                                                            <Label for="porcentajedisc" md={3}>Porcentaje discapacidad</Label>
                                                            <Col md={3}>
                                                                <InputGroup>
                                                                    <Input type="number" id="discapporc" name="discapporc" value={this.state.htoData.discapporc} onChange={this.handleChange} disabled={true} required />
                                                                    <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                        <Icon kind="porcentaje" fill='#FFFFFF' width={27} height={27} />
                                                                    </InputGroupAddon>
                                                                </InputGroup>
                                                                <TooltipItem content="Porcentaje de discapacidad" id="discapporc" />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row>
                                                            <Label for="numero_carnet" md={3}>Número de carnet de CONADIS</Label>
                                                            <Col md={3}>
                                                                <InputGroup>
                                                                    <Input type="text" name="discapcarnet" value={this.state.htoData.discapcarnet} onChange={this.handleChange} disabled={true} required />
                                                                    <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                        <Icon kind="numero" fill='#FFFFFF' width={27} height={27} />
                                                                    </InputGroupAddon>
                                                                </InputGroup>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row>
                                                            <Col md={3}>
                                                            </Col>
                                                            <Col md={3}>
                                                                <Datepicker
                                                                    value={this.state.htoData.fechaemisiondiscap}
                                                                    name="fechaemisiondiscap"
                                                                    id="fechaemisiondiscap"
                                                                    placeholder="Fecha emisión"
                                                                    onChange={this.handleSelectChange}
                                                                    disabled={true}
                                                                />
                                                            </Col>
                                                            <Col md={3}>
                                                                <Datepicker
                                                                    value={this.state.htoData.fechacaducidaddiscap}
                                                                    name="fechacaducidaddiscap"
                                                                    id="fechacaducidaddiscap"
                                                                    placeholder="Fecha caducidad"
                                                                    onChange={(value, name, tipo) => { this.handleSelectChange(value, name, tipo, this.state.htoData, this.state.tipoDiscapacidadSelected) }}
                                                                />
                                                            </Col>
                                                            {
                                                                //<Col md={3}>
                                                                //    <Row>
                                                                //        <Col md={8}>
                                                                //            <InputFileUpload
                                                                //                icon="upload"
                                                                //                onChange={this.handleFileUploadChange}
                                                                //                name="INC"
                                                                //                placeholder={this.state.htoData.refarchivocarnet ? "Actualizar Carnet CONADIS" : "Subir Carnet CONADIS"} />
                                                                //        </Col>
                                                                //        <Col md={4}>
                                                                //            <InputFileDownload tipo="carnet de discapacidad"
                                                                //                id="downloadINC"
                                                                //                refarchivo={this.state.htoData.refarchivocarnet}
                                                                //                name={"INC" + this.state.dtoData.numeroidentificacion + ".PDF"}
                                                                //                url={API_URL + "DatosGenerales/Refarchivo/INC/" + this.state.currentUser.idpersona}
                                                                //            />
                                                                //        </Col>
                                                                //    </Row>
                                                                //</Col>
                                                            }

                                                        </FormGroup>
                                                    </div>
                                                    :
                                                    null
                                                )
                                            }

                                            <FormGroup row>
                                                <Col md={3}>
                                                    <FormGroup>
                                                        <Label for="tieneenfercatastrofica">¿Usted padece una enfermedad catastrófica, rara y/o huérfana?*</Label>
                                                        <div className="row ml-1" >
                                                            <CustomInput
                                                                className="col-md-5"
                                                                type="radio"
                                                                checked={this.state.htoData.tieneenfercatastrofica === "S"}
                                                                value="S"
                                                                id="tieneenfercatastrofica"
                                                                name="tieneenfercatastrofica"
                                                                onChange={this.handleChange}
                                                                label="Sí"

                                                            />
                                                            <CustomInput
                                                                className="col-md-6"
                                                                type="radio"
                                                                value="N"
                                                                id="tieneenfercatastrofica2"
                                                                name="tieneenfercatastrofica"
                                                                checked={this.state.htoData.tieneenfercatastrofica === "N"}
                                                                onChange={this.handleChange}
                                                                label="No"

                                                            />
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                {
                                                    (this.state.htoData.tieneenfercatastrofica == "S") ?
                                                        <Col md={3}>
                                                            <Label for="">Certificado o aval de padecer una enfermedad catastrófica, rara y/o huérfana (PDF)*</Label>
                                                            <FormGroup row>
                                                                <Col md={(this.descargarEvidencias(this.state.htoData).length > 0 ? 10 : 12)}>
                                                                    <InputFileUpload
                                                                        icon="upload"
                                                                        onChange={this.handleFileUploadChange}
                                                                        name="ENC"
                                                                        placeholder={this.state.htoData.refarchivoenfercatastrofica ? "Actualizar documento" : "Subir documento"}
                                                                        required={true}
                                                                        stateFile={this.state.filesData[0] !== undefined}
                                                                    />

                                                                </Col>
                                                                <InputFileDownload tipo="Certificado o aval de padecer una enfermedad catastrófica, rara y/o huérfana"
                                                                    id="refarchivoenfercatastrofica"
                                                                    refarchivo={this.state.htoData.refarchivoenfercatastrofica}
                                                                    name={"DOCUMENTO-" + this.state.dtoData.numeroidentificacion + ".PDF"}
                                                                    url={API_URL + "DatosGenerales/Refarchivo/CCF/" + this.state.htoData.idhojavida}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        : ""
                                                }
                                            </FormGroup>

                                            <FormGroup check>
                                                <Label check>
                                                    <Input type="checkbox" onChange={this.toggleCheckbox} />{' '}
                                                    Solicito a la Dirección de Talento Humano, actualizar mi información de discapacidad,
                                                    con los datos que se encuentran en el MSP.
                                                </Label>
                                            </FormGroup>



                                            <Row>
                                                <Col md={6}>
                                                    <Button color="secondary" type="submit" className="btn btn-default" >Guardar</Button>
                                                </Col>
                                            </Row>
                                        </form >
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </>
            );

        return <div className="content">

            {contents}

        </div>;
    }

    // Returns the HTML Form to the render() method.

    private renderForm(tipoDiscapacidadList: Array<any>, tipoSangreList: Array<any>, tipoVacunaList: Array<any>, tiposEvidencia: Array<any>, htoData: SaludData, tipoDiscapacidadSelected:string) {
        //return (
        //    <>
        //        <Row> <Col></Col> </Row>
        //        <Row>
        //            <Col md={12}>
        //                {this.state.errorAlert}
        //                <Card className="principal">
        //                    <CardHeader>
        //                        <h5 className="title">SALUD</h5>
        //                    </CardHeader>
        //                    <CardBody className="main-content">
        //                        <div>
        //                            <form onSubmit={this.handleSave}>

        //                                <FormGroup row>
        //                                    <Label for="tipo_sangre" md={3}>Tipo de sangre*: </Label>
        //                                    <Col md={3}>
        //                                        <SelectItem
        //                                            options={tipoSangreList}
        //                                            value={this.state.dtoData.tiposangre ? this.state.dtoData.tiposangre.trim() : ""}
        //                                            placeholder="Tipo de sangre"
        //                                            name="tiposangre"
        //                                            id="tiposangre"
        //                                            //icon="fa-tint"
        //                                            icon="tipo_sangre"
        //                                            tieneDiscapacidad={true}
        //                                            onChange={this.handleSelectChange}
        //                                        />
        //                                    </Col>
        //                                </FormGroup>

        //                                <FormGroup row>
        //                                    <Label for="tienediscapacidad" sm={3}>Discapacidad*: </Label>
        //                                    <Col sm={9}>
        //                                        <div className="row ml-1" >
        //                                            {
        //                                                this.state.dtoData.tienediscapacidad === "S" ?
        //                                                    <CustomInput
        //                                                        className="col-md-1 mr-4"
        //                                                        type="radio"
        //                                                        checked={this.state.dtoData.tienediscapacidad === "S"}
        //                                                        value="S"
        //                                                        id="tienediscapacidad"
        //                                                        name="tienediscapacidad"
        //                                                        onChange={this.handleChange}
        //                                                        label="Sí"
        //                                                        disabled={true}
        //                                                    />
        //                                                    :
        //                                                    <CustomInput
        //                                                        className="col-md-6"
        //                                                        type="radio"
        //                                                        value="N"
        //                                                        id="tienediscapacidad2"
        //                                                        name="tienediscapacidad"
        //                                                        checked={this.state.dtoData.tienediscapacidad === "N"}
        //                                                        onChange={this.handleChange}
        //                                                        label="En el MSP, no registra información suya sobre alguna discapacidad."
        //                                                        disabled={true}
        //                                                    />
        //                                            }

        //                                        </div>
        //                                    </Col>
        //                                </FormGroup>
        //                                {
        //                                    (tieneDiscapacidad ?
        //                                        <div>
        //                                            <FormGroup row>
        //                                                <Label for="tipo_discapacidad" md={3}>Tipo discapacidad</Label>
        //                                                <Col md={3}>
        //                                                    <SelectItem
        //                                                        options={tipoDiscapacidadList}
        //                                                        value={this.state.htoData.discaptipo}
        //                                                        placeholder="Tipo discapacidad"
        //                                                        name="discaptipo"
        //                                                        id="discaptipo"
        //                                                        //icon="fa-wheelchair"
        //                                                        icon="discapacidad"
        //                                                        tieneDiscapacidad={tieneDiscapacidad}
        //                                                        onChange={this.handleSelectChange}
        //                                                        disabled={true}
        //                                                    />
        //                                                </Col>
        //                                            </FormGroup>
        //                                            <FormGroup row>
        //                                                <Label for="porcentajedisc" md={3}>Porcentaje discapacidad</Label>
        //                                                <Col md={3}>
        //                                                    <InputGroup>
        //                                                        <Input type="number" id="discapporc" name="discapporc" value={this.state.htoData.discapporc} onChange={this.handleChange} disabled={true} required />
        //                                                        <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
        //                                                            <Icon kind="porcentaje" fill='#FFFFFF' width={27} height={27} />
        //                                                        </InputGroupAddon>
        //                                                    </InputGroup>
        //                                                    <TooltipItem content="Porcentaje de discapacidad" id="discapporc" />
        //                                                </Col>
        //                                            </FormGroup>
        //                                            <FormGroup row>
        //                                                <Label for="numero_carnet" md={3}>Número de carnet de CONADIS</Label>
        //                                                <Col md={3}>
        //                                                    <InputGroup>
        //                                                        <Input type="text" name="discapcarnet" value={this.state.htoData.discapcarnet} onChange={this.handleChange} disabled={true} required />
        //                                                        <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
        //                                                            <Icon kind="numero" fill='#FFFFFF' width={27} height={27} />
        //                                                        </InputGroupAddon>
        //                                                    </InputGroup>
        //                                                </Col>
        //                                            </FormGroup>
        //                                            <FormGroup row>
        //                                                <Col md={3}>
        //                                                </Col>
        //                                                <Col md={3}>
        //                                                    <Datepicker
        //                                                        value={this.state.htoData.fechaemisiondiscap}
        //                                                        name="fechaemisiondiscap"
        //                                                        id="fechaemisiondiscap"
        //                                                        placeholder="Fecha emisión"
        //                                                        onChange={this.handleSelectChange}
        //                                                        disabled={true}
        //                                                    />
        //                                                </Col>
        //                                                <Col md={3}>
        //                                                    <Datepicker
        //                                                        value={this.state.htoData.fechacaducidaddiscap}
        //                                                        name="fechacaducidaddiscap"
        //                                                        id="fechacaducidaddiscap"
        //                                                        placeholder="Fecha caducidad"
        //                                                        onChange={(value, name, tipo) => { this.handleSelectChange(value,name,tipo,htoData,tipoDiscapacidadSelected) }}
        //                                                    />
        //                                                </Col>
        //                                                {
        //                                                    //<Col md={3}>
        //                                                    //    <Row>
        //                                                    //        <Col md={8}>
        //                                                    //            <InputFileUpload
        //                                                    //                icon="upload"
        //                                                    //                onChange={this.handleFileUploadChange}
        //                                                    //                name="INC"
        //                                                    //                placeholder={this.state.htoData.refarchivocarnet ? "Actualizar Carnet CONADIS" : "Subir Carnet CONADIS"} />
        //                                                    //        </Col>
        //                                                    //        <Col md={4}>
        //                                                    //            <InputFileDownload tipo="carnet de discapacidad"
        //                                                    //                id="downloadINC"
        //                                                    //                refarchivo={this.state.htoData.refarchivocarnet}
        //                                                    //                name={"INC" + this.state.dtoData.numeroidentificacion + ".PDF"}
        //                                                    //                url={API_URL + "DatosGenerales/Refarchivo/INC/" + this.state.currentUser.idpersona}
        //                                                    //            />
        //                                                    //        </Col>
        //                                                    //    </Row>
        //                                                    //</Col>
        //                                                }

        //                                            </FormGroup>
        //                                        </div>
        //                                        :
        //                                        null
        //                                    )
        //                                }

        //                                <FormGroup row>
        //                                    <Col md={3}>
        //                                        <FormGroup>
        //                                            <Label for="tieneenfercatastrofica">¿Usted padece una enfermedad catastrófica, rara y/o huérfana?*</Label>
        //                                            <div className="row ml-1" >
        //                                                <CustomInput
        //                                                    className="col-md-5"
        //                                                    type="radio"
        //                                                    checked={this.state.htoData.tieneenfercatastrofica === "S"}
        //                                                    value="S"
        //                                                    id="tieneenfercatastrofica"
        //                                                    name="tieneenfercatastrofica"
        //                                                    onChange={this.handleChange}
        //                                                    label="Sí"

        //                                                />
        //                                                <CustomInput
        //                                                    className="col-md-6"
        //                                                    type="radio"
        //                                                    value="N"
        //                                                    id="tieneenfercatastrofica2"
        //                                                    name="tieneenfercatastrofica"
        //                                                    checked={this.state.htoData.tieneenfercatastrofica === "N"}
        //                                                    onChange={this.handleChange}
        //                                                    label="No"

        //                                                />
        //                                            </div>
        //                                        </FormGroup>
        //                                    </Col>
        //                                    {
        //                                        (this.state.htoData.tieneenfercatastrofica == "S") ?
        //                                            <Col md={3}>
        //                                                <Label for="">Certificado o aval de padecer una enfermedad catastrófica, rara y/o huérfana (PDF)*</Label>
        //                                                <FormGroup row>
        //                                                    <Col md={(this.descargarEvidencias(this.state.htoData).length > 0 ? 10 : 12)}>
        //                                                        <InputFileUpload
        //                                                            icon="upload"
        //                                                            onChange={this.handleFileUploadChange}
        //                                                            name="ENC"
        //                                                            placeholder={this.state.htoData.refarchivoenfercatastrofica ? "Actualizar documento" : "Subir documento"}
        //                                                            required={true}
        //                                                            stateFile={this.state.filesData[0] !== undefined}
        //                                                        />

        //                                                    </Col>
        //                                                    <InputFileDownload tipo="Certificado o aval de padecer una enfermedad catastrófica, rara y/o huérfana"
        //                                                        id="refarchivoenfercatastrofica"
        //                                                        refarchivo={this.state.htoData.refarchivoenfercatastrofica}
        //                                                        name={"DOCUMENTO-" + this.state.dtoData.numeroidentificacion + ".PDF"}
        //                                                        url={API_URL + "DatosGenerales/Refarchivo/CCF/" + this.state.htoData.idhojavida}
        //                                                    />
        //                                                </FormGroup>
        //                                            </Col>
        //                                            : ""
        //                                    }
        //                                </FormGroup>

        //                                <FormGroup check>
        //                                    <Label check>
        //                                        <Input type="checkbox" onChange={this.toggleCheckbox} />{' '}
        //                                        Solicito a la Dirección de Talento Humano, actualizar mi información de discapacidad,
        //                                        con los datos que se encuentran en el MSP.
        //                                    </Label>
        //                                </FormGroup>

                                        

        //                                <Row>
        //                                    <Col md={6}>
        //                                        <Button color="secondary" type="submit" className="btn btn-default" >Guardar</Button>
        //                                    </Col>
        //                                </Row>
        //                            </form >
        //                        </div>
        //                    </CardBody>
        //                </Card>
        //            </Col>
        //        </Row>

        //    </>
        //);
    }
}

export default Salud;